(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-footer"] && !Shopify.designMode) return;
  try {
    // A bare GET form lands on "/?"; with JS, go to the clean root URL.
  document.addEventListener("submit", (event) => {
    const form = event.target.closest("[data-keep-browsing]");
    if (!form) return;
    event.preventDefault();
    window.location.assign(form.getAttribute("action"));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delivery-date-picker"] && !Shopify.designMode) return;
  try {
    class DeliveryDatePicker extends HTMLElement {
    async connectedCallback() {
      const [{ getBooking }, dates] = await Promise.all([
        import("chari/booking"),
        import("chari/dates"),
      ]);
      this.dates = dates;
      this.booking = getBooking();
      this.calendarOpen = false;
      this.viewDate = dates.startOfMonth(new Date());

      this.render();
      this.booking.addEventListener("change", () => this.render());

      this.addEventListener("click", (event) => {
        const chip = event.target.closest("[data-quick-date-chip]");
        if (chip) {
          const iso = chip.dataset.date;
          this.booking.setDate(new Date(`${iso}T00:00:00`));
          this.calendarOpen = false;
          this.render();
          return;
        }
        if (event.target.closest("[data-toggle-calendar]")) {
          this.calendarOpen = !this.calendarOpen;
          this.viewDate = this.dates.startOfMonth(new Date());
          this.render();
          return;
        }
        const dayButton = event.target.closest("[data-calendar-day]");
        if (dayButton && !dayButton.disabled) {
          const iso = dayButton.dataset.date;
          this.booking.setDate(new Date(`${iso}T00:00:00`));
          return;
        }
        if (event.target.closest("[data-calendar-prev]")) {
          this.viewDate = this.dates.addMonths(this.viewDate, -1);
          this.render();
          return;
        }
        if (event.target.closest("[data-calendar-next]")) {
          this.viewDate = this.dates.addMonths(this.viewDate, 1);
          this.render();
        }
      });
    }

    render() {
      const chipsTarget = this.querySelector("[data-chips]");
      if (!chipsTarget) return;

      const { formatDate, isSameDay, startOfDay, toISODate } = this.dates;
      const today = startOfDay(new Date());
      const isBlocked = (d) => this.booking.isDateUnavailable(d);
      const quickDates = [];
      let cursor = today;
      let guard = 0;
      while (quickDates.length < 3 && guard < 400) {
        if (!isBlocked(cursor)) quickDates.push(cursor);
        cursor = this.dates.addDays(cursor, 1);
        guard++;
      }

      const selected = this.booking.date;
      const chipsHtml = quickDates
        .map((d) => {
          const isSelected = isSameDay(d, selected);
          return `<button type="button" data-quick-date-chip data-date="${toISODate(d)}" class="c-delivery-picker__chip${isSelected ? " is-selected" : ""}">
            <span class="c-delivery-picker__chip-weekday">${formatDate(d, "EEE")}</span>
            <span class="c-delivery-picker__chip-date">${formatDate(d, "d MMM")}</span>
          </button>`;
        })
        .join("");

      const toggleHtml = `<button type="button" data-toggle-calendar class="c-delivery-picker__chip c-delivery-picker__chip--toggle${this.calendarOpen ? " is-open" : ""}" aria-expanded="${this.calendarOpen}">
        <span class="c-delivery-picker__chip-date">Another date</span>
      </button>`;

      chipsTarget.innerHTML = `<div class="c-delivery-picker__chips">${chipsHtml}${toggleHtml}</div>`;

      let calendarSlot = this.querySelector("[data-calendar-slot]");
      if (!calendarSlot) {
        calendarSlot = document.createElement("div");
        calendarSlot.setAttribute("data-calendar-slot", "");
        this.appendChild(calendarSlot);
      }
      calendarSlot.innerHTML = this.calendarOpen ? this.renderCalendar(today, selected, isBlocked) : "";
    }

    renderCalendar(today, selected, isBlocked) {
      const { formatDate, isSameDay, addDays, toISODate } = this.dates;
      const view = this.viewDate;
      const firstOfMonth = new Date(view.getFullYear(), view.getMonth(), 1);
      // Monday-start week index: JS getDay() is 0=Sun..6=Sat.
      const firstWeekday = (firstOfMonth.getDay() + 6) % 7;
      const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      const rangeEnd = addDays(selected, 3);

      let cells = "";
      for (let i = 0; i < firstWeekday; i++) {
        cells += `<span class="c-delivery-picker__day c-delivery-picker__day--blank"></span>`;
      }
      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(view.getFullYear(), view.getMonth(), day);
        const iso = toISODate(date);
        const beforeToday = date.getTime() < today.getTime();
        const unavailable = !beforeToday && isBlocked(date);
        const blocked = beforeToday || unavailable;
        const isSelected = isSameDay(date, selected);
        const inRange = date.getTime() >= selected.getTime() && date.getTime() <= rangeEnd.getTime();
        const classes = ["c-delivery-picker__day"];
        if (inRange) classes.push("c-delivery-picker__day--in-range");
        if (isSelected) classes.push("c-delivery-picker__day--selected");
        if (beforeToday) classes.push("c-delivery-picker__day--past");
        if (unavailable) classes.push("c-delivery-picker__day--unavailable");
        cells += `<button type="button" data-calendar-day data-date="${iso}" class="${classes.join(" ")}" ${blocked ? "disabled" : ""} aria-label="${formatDate(date, "d MMMM yyyy")}" aria-current="${isSelected ? "date" : "false"}">${day}</button>`;
      }

      const canGoPrev = this.dates.startOfMonth(view).getTime() > this.dates.startOfMonth(today).getTime();
      const weekdayLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      const loadingHtml = this.booking.isLoading
        ? `<div class="c-delivery-picker__loading">Loading availability…</div>`
        : "";

      return `<div class="c-delivery-picker__calendar" data-delivery-date-picker role="group" aria-label="Choose a delivery date" aria-busy="${this.booking.isLoading}">
        ${loadingHtml}
        <div class="c-delivery-picker__calendar-nav">
          <button type="button" data-calendar-prev class="c-delivery-picker__calendar-nav-btn" aria-label="Previous month" ${canGoPrev ? "" : "disabled"}>‹</button>
          <span class="c-delivery-picker__calendar-label">${formatDate(view, "MMMM yyyy")}</span>
          <button type="button" data-calendar-next class="c-delivery-picker__calendar-nav-btn" aria-label="Next month">›</button>
        </div>
        <div class="c-delivery-picker__weekdays">${weekdayLabels.map((w) => `<span class="c-delivery-picker__weekday">${w}</span>`).join("")}</div>
        <div class="c-delivery-picker__days">${cells}</div>
      </div>`;
    }
  }

  if (!customElements.get("delivery-date-picker")) {
    customElements.define("delivery-date-picker", DeliveryDatePicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    class ChariDrawer extends HTMLElement {
    connectedCallback() {
      this.dialogEl = this.querySelector("dialog");
      if (!this.dialogEl) return;

      this.dialogEl.addEventListener("cancel", (event) => {
        // Animate the close instead of letting the browser snap it shut.
        event.preventDefault();
        this.close();
      });

      this.dialogEl.addEventListener("click", (event) => {
        if (event.target === this.dialogEl) this.close();
      });

      this.addEventListener("click", (event) => {
        if (event.target.closest("[data-drawer-close]")) {
          this.close();
          return;
        }
        // A trigger can be anywhere inside <chari-drawer> but outside the
        // <dialog> itself (the dialog's own contents are closed/hidden until
        // .open() runs, so they can never be the source of an "open" click).
        const trigger = event.target.closest("[data-drawer-open]");
        if (trigger && !this.dialogEl.contains(trigger)) this.open();
      });

      const openEventName = this.dataset.openEvent;
      if (openEventName) {
        window.addEventListener(openEventName, () => this.open());
      }
    }

    open() {
      if (!this.dialogEl || this.dialogEl.open) return;
      this.dialogEl.showModal();
      // Two rAFs: the first lets the browser paint the just-opened dialog at
      // its resting (offscreen) transform, the second then adds the class
      // that animates it in — doing it in one frame skips the transition.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.dialogEl.classList.add("is-visible");
        });
      });

      const focusSelector = this.dialogEl.dataset.initialFocus;
      const focusTarget = focusSelector && this.dialogEl.querySelector(focusSelector);
      if (focusTarget) focusTarget.focus();

      this.dispatchEvent(new CustomEvent("chari:drawer-open", { bubbles: true }));
    }

    close() {
      if (!this.dialogEl || !this.dialogEl.open) return;
      this.dialogEl.classList.remove("is-visible");

      let finished = false;
      const finish = () => {
        if (finished || !this.dialogEl.open) return;
        finished = true;
        this.dialogEl.close();
        this.dispatchEvent(new CustomEvent("chari:drawer-close", { bubbles: true }));
      };
      this.dialogEl.addEventListener("transitionend", finish, { once: true });
      // Fallback in case the transition never fires (reduced motion, a
      // browser quirk) — never leave the drawer stuck open.
      setTimeout(finish, 350);
    }

    toggle() {
      if (this.dialogEl && this.dialogEl.open) this.close();
      else this.open();
    }
  }

  if (!customElements.get("chari-drawer")) {
    customElements.define("chari-drawer", ChariDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.mainImages = Array.from(this.querySelectorAll(".c-gallery-root__main-img"));
      this.thumbButtons = Array.from(this.querySelectorAll("[data-gallery-thumb]"));
      this.dots = Array.from(this.querySelectorAll(".c-gallery-root__dot"));
      this.lightboxImages = Array.from(this.querySelectorAll(".c-gallery-root__lightbox-img"));
      this.lightbox = this.querySelector(".c-gallery-root__lightbox");
      this.mainButton = this.querySelector("[data-gallery-open]");
      this.activeIndex = 0;

      if (this.mainImages[0]) this.mainImages[0].classList.add("is-active");
      if (this.dots[0]) this.dots[0].classList.add("is-active");
      if (this.lightboxImages[0]) this.lightboxImages[0].classList.add("is-active");

      this.mainButton?.addEventListener("click", () => this.openLightbox(this.activeIndex));

      this.thumbButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
          this.selectIndex(index);
          this.openLightbox(index);
        });
        button.addEventListener("keydown", (event) => this.handleThumbKeydown(event, index));
      });

      this.querySelector("[data-gallery-close]")?.addEventListener("click", () => this.closeLightbox());
      this.lightbox?.addEventListener("cancel", (event) => {
        event.preventDefault();
        this.closeLightbox();
      });
      this.lightbox?.addEventListener("click", (event) => {
        if (event.target === this.lightbox) this.closeLightbox();
      });
      this.lightbox?.addEventListener("keydown", (event) => {
        if (event.key === "ArrowLeft") this.step(-1);
        else if (event.key === "ArrowRight") this.step(1);
      });

      let touchStartX = 0;
      this.lightbox?.addEventListener("touchstart", (event) => {
        touchStartX = event.touches[0].clientX;
      });
      this.lightbox?.addEventListener("touchend", (event) => {
        const delta = event.changedTouches[0].clientX - touchStartX;
        const SWIPE_THRESHOLD = 50;
        if (delta > SWIPE_THRESHOLD) this.step(-1);
        else if (delta < -SWIPE_THRESHOLD) this.step(1);
      });
    }

    handleThumbKeydown(event, currentIndex) {
      let nextIndex = -1;
      if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        nextIndex = Math.min(currentIndex + 1, this.thumbButtons.length - 1);
      } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        nextIndex = Math.max(currentIndex - 1, 0);
      }
      if (nextIndex >= 0 && nextIndex !== currentIndex) {
        event.preventDefault();
        this.selectIndex(nextIndex);
        const nextButton = this.thumbButtons[nextIndex];
        nextButton.focus();
        nextButton.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      }
    }

    selectIndex(index) {
      this.activeIndex = index;
      this.mainImages.forEach((el, i) => el.classList.toggle("is-active", i === index));
      this.dots.forEach((el, i) => el.classList.toggle("is-active", i === index));
      this.thumbButtons.forEach((el, i) => {
        el.classList.toggle("is-active", i === index);
        el.setAttribute("aria-current", i === index ? "true" : "false");
      });
      const activeThumb = this.thumbButtons[index];
      if (activeThumb && this.mainButton) {
        this.mainButton.style.setProperty("--gallery-ratio", getComputedStyle(activeThumb).getPropertyValue("--gallery-ratio"));
      }
    }

    step(delta) {
      const count = this.lightboxImages.length;
      if (!count) return;
      const next = (this.activeIndex + delta + count) % count;
      this.selectIndex(next);
      this.updateLightbox(next);
    }

    updateLightbox(index) {
      this.lightboxImages.forEach((el, i) => el.classList.toggle("is-active", i === index));
    }

    openLightbox(index) {
      this.selectIndex(index);
      this.updateLightbox(index);
      if (this.lightbox && !this.lightbox.open) this.lightbox.showModal();
    }

    closeLightbox() {
      if (this.lightbox && this.lightbox.open) this.lightbox.close();
    }
  }

  if (!customElements.get("product-gallery")) {
    customElements.define("product-gallery", ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
